// 演示数据：价格、配置和描述均为虚构，不代表官方商品信息。
export const mockBrands = [
  { id: "infinix", name: "Infinix", color: "#192923", logoColor: "#152a22" },
  { id: "iqoo", name: "iQOO", color: "#25252c", logoColor: "#21212b" },
  { id: "itel", name: "itel", color: "#bd2447", logoColor: "#ec174b" },
  { id: "poco", name: "POCO", color: "#88701a", logoColor: "#8b7100" },
  { id: "realme", name: "realme", color: "#93691d", logoColor: "#9d7700" },
  { id: "samsung", name: "SAMSUNG", color: "#253663", logoColor: "#174991" },
  { id: "tecno", name: "TECNO", color: "#363e97", logoColor: "#1474df" },
  { id: "vivo", name: "vivo", color: "#473798", logoColor: "#526be1" },
];

const rows = [
  ["infinix", "Note 60 Pro", 389, 8, 128, "5G"],
  ["infinix", "Note Edge", 339, 8, 128, "5G"],
  ["infinix", "Note Edge", 319, 8, 256, "5G"],
  ["infinix", "Hot 70 Pro", 289, 6, 128, "4G"],
  ["infinix", "Note 50", 239, 8, 256, "4G"],
  ["infinix", "Hot 60", 189, 6, 128, "4G"],
  ["infinix", "Smart 10", 129, 4, 128, "4G"],
  ["iqoo", "Z11x", 329, 8, 128, "5G"],
  ["iqoo", "Z10 Lite", 249, 8, 256, "5G"],
  ["iqoo", "Z9 Lite", 199, 6, 128, "5G"],
  ["itel", "S25 Ultra", 229, 8, 256, "4G"],
  ["itel", "S25", 179, 6, 128, "4G"],
  ["itel", "P65", 149, 4, 128, "4G"],
  ["itel", "A90", 100, 4, 128, "4G"],
  ["poco", "M8", 289, 8, 128, "5G"],
  ["poco", "M8", 279, 6, 128, "5G"],
  ["poco", "M8 Power", 259, 6, 128, "5G"],
  ["poco", "C85", 189, 6, 128, "4G"],
  ["poco", "C75", 139, 4, 128, "4G"],
  ["realme", "16T", 399, 8, 128, "5G"],
  ["realme", "16x", 379, 6, 256, "5G"],
  ["realme", "P4 Power", 359, 8, 256, "5G"],
  ["realme", "Narzo Power", 339, 8, 128, "5G"],
  ["realme", "P4x", 299, 8, 128, "5G"],
  ["realme", "P4R", 279, 6, 128, "5G"],
  ["realme", "C75", 239, 6, 128, "4G"],
  ["realme", "C71", 169, 4, 128, "4G"],
  ["samsung", "Galaxy F70 Pro", 289, 6, 128, "5G"],
  ["samsung", "Galaxy A26", 249, 8, 256, "5G"],
  ["samsung", "Galaxy A17", 219, 6, 128, "5G"],
  ["samsung", "Galaxy A07", 149, 4, 128, "4G"],
  ["tecno", "Pova Curve 2", 339, 8, 128, "5G"],
  ["tecno", "Spark 50", 289, 8, 128, "5G"],
  ["tecno", "Camon 40", 249, 8, 256, "4G"],
  ["tecno", "Spark 40", 189, 6, 128, "4G"],
  ["tecno", "Pop 10", 119, 4, 128, "4G"],
  ["vivo", "Y51 Pro", 400, 8, 128, "5G"],
  ["vivo", "T5x", 329, 8, 128, "5G"],
  ["vivo", "Y39", 249, 8, 256, "5G"],
  ["vivo", "Y29", 199, 6, 128, "4G"],
  ["vivo", "Y19s", 159, 4, 128, "4G"],
];

// 国家分配仅用于演示筛选，不代表真实销售地区。
const legacyCountries = [
  { id: "country-in", name: "印度" },
  { id: "country-id", name: "印度尼西亚" },
  { id: "country-ng", name: "尼日利亚" },
  { id: "country-eg", name: "埃及" },
  { id: "country-sa", name: "沙特阿拉伯" },
  { id: "country-pk", name: "巴基斯坦" },
];

// 独立配置字典；不从当前商品列表、筛选结果或价格区间推导。
export const mockProductFilterOptions = {
  ram: [4, 6, 8, 12],
  storage: [128, 256, 512],
  network: ["4G", "5G"],
};

export const mockProducts = rows.map(
  ([brandId, name, price, ram, storage, network], i) => ({
    id: `demo-${i + 1}`,
    brandId,
    name,
    price,
    ram,
    storage,
    network,
    // 演示第二张卡片有多组配置；同卡片价格为演示价，不代表每组配置各自价格。
    configurations:
      i === 1
        ? [
            [ram, storage],
            [12, 512],
          ]
        : [[ram, storage]],
    // 同型号的多个配置使用相同模拟上市日期；并非真实上市信息。
    launchDate: `2026-${String((rows.findIndex((row) => row[0] === brandId && row[1] === name) % 10) + 1).padStart(2, "0")}-15`,
    currency: "USD",
    countryId: legacyCountries[i % legacyCountries.length].id,
    // 仅兼容旧的纯矩阵测试；API 不返回国家显示名。
    country: legacyCountries[i % legacyCountries.length].name,
    market: "模拟国家市场",
    description:
      "用于商品价格分布演示。此处可以展示商品卖点、上市时间、区域及其他接口字段。",
  }),
);

// 独立国家接口目前仅提供 global；与品牌接口采用相同基础字段。
export const mockCountries = [
  {
    id: 1,
    name: "global",
    code: "global",
    sort: 0,
    color: null,
    logo_url: null,
  },
];
const apiBrandIds = {
  tecno: 1,
  infinix: 2,
  iqoo: 3,
  itel: 4,
  poco: 5,
  realme: 6,
  samsung: 7,
  vivo: 8,
};
// 原始接口 DTO：数字 ID，color 允许 null；卡片展示颜色在 presentation 层补齐。
export const mockApiBrands = mockBrands.map((brand, index) => ({
  id: apiBrandIds[brand.id],
  name: brand.name,
  code: brand.id,
  sort: index,
  color: null,
  logo_url: null,
}));
export const mockApiProducts = mockProducts.map(({ country, ...product }) => ({
  ...product,
  brandId: apiBrandIds[product.brandId],
  countryId: 1,
}));
